import { Field } from 'formik'
import React, { ReactElement, ReactNode } from 'react'

import { useTranslation } from '@lib/i18n'
import { required } from '@lib/validators'
import CheckboxField from '@ui/Checkbox/Field'

interface Props {
  label: ReactNode
}

const TermsAndPrivacyField = ({ label }: Props): ReactElement => {
  const { t } = useTranslation()
  return (
    <Field
      component={CheckboxField}
      label={label}
      name={'termsAndPrivacy'}
      validate={required}
      errorMessage={t('booking.form.errors.termsAndPrivacy')}
      dataTag="terms-and-privacy-checkbox"
    />
  )
}

export default TermsAndPrivacyField
